
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEyeSlash, faEye } from "@fortawesome/free-solid-svg-icons";
import { faAngleLeft, faEnvelope,faUser, faUnlockAlt } from "@fortawesome/free-solid-svg-icons";
import { faFacebookF, faGithub, faTwitter } from "@fortawesome/free-brands-svg-icons";
import { Col, Row, Form, Card, Button, FormCheck, Container, InputGroup } from '@themesberg/react-bootstrap';
import { Link } from 'react-router-dom';

import { Routes } from "../../routes";
// import BgImage from "../../assets/img/illustrations/signin.svg";
import BgImage from "../../assets/img/illustrations/6209994.svg";
import { useState } from "react";
import api from "../../api/axios";
import { loginUser, resetPassword } from "../../api/services";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useHistory } from "react-router-dom";
import PasswordInput from "../components/PasswordInput";
import Preloader from "../../components/Preloader"; // Path to your code above

export default function Signin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { login } = useContext(AuthContext);
  const [error, setError] = useState("");
  const history = useHistory();
  const [showLoader, setShowLoader] = useState(false); // Controls the loader
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log({ email, password });
    setShowLoader(true);
    try {
      const data = await loginUser({
        email,
        password,
      });

      console.log("signin Success:", data);
      login(data.token);
      sessionStorage.setItem("email", email);
      sessionStorage.setItem("access", data.token);
      console.log(data.token);
      sessionStorage.setItem("role", data.user.role);
      history.push(Routes.DashboardOverview.path);
      // Redirect to login
      // window.location.href = "/otp-verification";

    } catch (error) {
      console.log("signin Error:", error.response?.data || error.message);
      setError(error.response?.data.error);
    }
    finally {
      setShowLoader(false);
    }
  };
  const handleLostButton = async (e) => {
    // Implement lost password functionality here
    console.log("Lost password clicked");
    e.preventDefault();
    try {
      //   const data = await resetPassword({
      //     email,
      //   });
      //   console.log("Password reset email sent:", data);
      history.push(Routes.ForgotPassword.path);
      // Optionally, show a success message to the user
    } catch (error) {
      console.error("Error sending password reset email:", error);
      // Optionally, show an error message to the user
    }
  };
  return (
    <main>
      <Preloader show={showLoader} />
      <section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5" >
        <Container>
          <p className="text-center">
            <Card.Link as={Link} to={Routes.Presentation.path} className="text-gray-700">
              <FontAwesomeIcon icon={faAngleLeft} className="me-2" /> Back to homepage
            </Card.Link>
          </p>
          <Row className="justify-content-center form-bg-image" style={{ backgroundImage: `url(${BgImage})` }}>
            <Col lg={12} className="d-flex align-items-center justify-content-center">
              <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                <div className="text-center text-md-center mb-4 mt-md-0">
                  <h3 className="mb-0">Sign in to our platform</h3>
                </div>
                {error && (<div class="alert alert-danger">
                  {error}
                </div>)}
                <Form className="mt-4" onSubmit={handleSubmit} >
                  <Form.Group id="email" className="mb-4">
                    <Form.Label>Your Email or Username</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faUser} />
                      </InputGroup.Text>
                      {/* <Form.Control autoFocus required type="email" placeholder="example@company.com" /> */}
                      <Form.Control
                        autoFocus
                        required
                        type="email"
                        placeholder="Username or Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </InputGroup>
                  </Form.Group>
                  <Form.Group>
                    <Form.Group id="password" className="mb-4">
                      <Form.Label>Your Password</Form.Label>
                      <PasswordInput
                        required
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />

                    </Form.Group>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <Form.Check type="checkbox">
                        <FormCheck.Input id="defaultCheck5" className="me-2" />
                        <FormCheck.Label htmlFor="defaultCheck5" className="mb-0">Remember me</FormCheck.Label>
                      </Form.Check>
                      <Card.Link className="small text-end" onClick={handleLostButton}>
                        Lost password?
                      </Card.Link>
                    </div>
                  </Form.Group>
                  <Button variant="primary" type="submit" className="w-100">
                    Sign in
                  </Button>
                </Form>

                {/* <div className="mt-3 mb-4 text-center">
                  <span className="fw-normal">or login with</span>
                </div>
                <div className="d-flex justify-content-center my-4">
                  <Button variant="outline-light" className="btn-icon-only btn-pill text-facebook me-2">
                    <FontAwesomeIcon icon={faFacebookF} />
                  </Button>
                  <Button variant="outline-light" className="btn-icon-only btn-pill text-twitter me-2">
                    <FontAwesomeIcon icon={faTwitter} />
                  </Button>
                  <Button variant="outline-light" className="btn-icon-only btn-pil text-dark">
                    <FontAwesomeIcon icon={faGithub} />
                  </Button>
                </div> */}
                <div className="d-flex justify-content-center align-items-center mt-4">
                  <span className="fw-normal">
                    Not registered?
                    <Card.Link as={Link} to={Routes.Signup.path} className="fw-bold">
                      {` Create account `}
                    </Card.Link>
                  </span>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
};

